import { useEffect, useState } from "react";
import IconComponent from "./Icon";
import { FiInfo } from "react-icons/fi";
import { useNavigate } from "react-router-dom";

const noCover = 'https://dryofg8nmyqjw.cloudfront.net/images/no-cover.png';

interface LastReadBooksProps {
    library: any[]; // Define the type of elements in the library array if known
}


const LastReadBooks: React.FC<LastReadBooksProps> = ({library}) => {
    const [lastBooks, setLastBooks] = useState<any[]>([]);

    const navigate = useNavigate();
    

    const formatData = () => {
        // Filter the library to only include books that have been read
        const readBooks = library.filter((book: any) => book['Read Count'] > 0);

        // Sort the read books by date read in descending order
        const sortedBooks = readBooks.sort((a: any, b: any) => {
            const dateA = new Date(a['Date Read']);
            const dateB = new Date(b['Date Read']);
            return dateB.getTime() - dateA.getTime();
        });

        // Get the top 5 books
        const topBooks = sortedBooks.slice(0, 5);

        setLastBooks(topBooks);
    }

    const formatDate = (date: Date) => {
        const formattedDate = new Date(date).toLocaleDateString('nl-NL', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        })
        return formattedDate
    }

    useEffect(() => {
        formatData();
    }, [library]);


    if (library.length <= 0) {
        // loader
        return (
             <div className="bg-white rounded-3xl shadow-lg p-4 min-h-64 h-full mt-[40px] mb-[40px]">
                <div className="loader"></div> 
            </div>
        )
    }


    return (
        <div className="bg-white rounded-3xl shadow-lg p-4 min-h-64 h-full mt-[40px] mb-[40px]">
            <h1 className="text-2xl font-bold  text-[#60637A] mb-[20px]">
                    Last read books
            </h1>
            <div className=" grid md:grid-cols-5 grid-cols-1">
                {lastBooks.map((book: any, key: number) => (
                    <div key={key} className="flex flex-col items-center justify-center">
                       
                        <div className="relative w-32 h-48">
                        <img src={book['Cover URL'] || noCover } alt={book['Title']} className="w-32 h-48 object-cover rounded-lg" /> 
                            <div 
                            className="absolute top-0 left-0 right-0 bottom-0 h-full bg-black bg-opacity-75 flex items-center justify-center opacity-0 hover:opacity-100 transition-opacity duration-300 rounded-lg cursor-pointer"
                            onClick={() => navigate(`/Book/${book['Book Id']}`)}
                            >
                            <IconComponent icon={FiInfo} width={30} color="#ffffff" className="drop-shadow-xl" />
                            </div>
                        </div>
                         <p className=" ">{formatDate(book['Date Read'])}</p>
                        {/* <p className="font-bold">{book['Title']}</p>
                        <p className="italic text-xs">{book['Author']}</p> */}
                    </div>
                ))}
            </div>


        </div>
    )
}

export default LastReadBooks